module.exports = __webpack_public_path__ + "static/media/weather_3.7eb790c9.svg";